import Select from '../../../../components/select/select';

import './styles.scss';

export interface Option {
  name: string;
  value: string;
}

export interface SettingGroupOption {
  title: string;
  subtitle: string;
  options: Option[];
  value: string;
  setValue: (value: string) => void;
  className?: string;
}

export interface SettingGroupProps {
  title: string;
  options: SettingGroupOption[];
}

const SettingGroup: React.FC<SettingGroupProps> = ({ title, options }) => (
  <div className="setting-group-container">
    <h1 className="title">{title}</h1>
    <div className="options-container">
      {options.map((opt, idx) => (
        <div className="option" key={idx}>
          <div className="option-description">
            <div className="option-title">{opt.title}</div>
            <div className="option-subtitle">{opt.subtitle}</div>
          </div>
          <div className="option-selector">
            <Select
              values={opt.options}
              defaultValue={opt.options.find((o) => o.value === opt.value) || opt.options[0]}
              onChange={(value: string) => {
                opt.setValue(value);
              }}
              className={opt.className || ''}
              label=""
              multiSelect={false}
            />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default SettingGroup;
